// StatusChip.tsx
import React from "react";
import { Chip } from "@mui/material";

export interface StatusChipProps {
  approved: boolean;
}

export const StatusChip: React.FC<StatusChipProps> = ({ approved }) => {
    return (
        <Chip
            label={approved ? "Approved" : "Pending"}
            color={approved ? "success" : "warning"}
            variant="outlined"
            size="medium"
        />
    );
}